(() => {
  if (window.slynaraProductCardSwatches) return;
  window.slynaraProductCardSwatches = true;

  const buttonSelector = '.slynara-product-card__swatch-button';

  const selectSwatch = (button, userInitiated = true) => {
    if (!button || button.disabled) return;

    const card = button.closest('.slynara-product-card');
    if (!card) return;

    card.querySelectorAll(buttonSelector).forEach((swatch) => {
      swatch.setAttribute('aria-pressed', String(swatch === button));
    });

    card.dataset.selectedColor = button.dataset.color;
    card.dataset.selectedVariantId = button.dataset.variantId;
    card.classList.toggle('slynara-product-card--color-selected', userInitiated);

    const image = card.querySelector('.slynara-product-card__image--primary');
    if (image && button.dataset.mediaSrc) {
      image.src = button.dataset.mediaSrc;
      if (button.dataset.mediaSrcset) image.srcset = button.dataset.mediaSrcset;
      image.alt = button.dataset.mediaAlt || image.alt;
    }

    const quickAddButton = card.querySelector('.slynara-product-card__quick-add-button[data-product-url]');
    if (quickAddButton && button.dataset.variantUrl) {
      quickAddButton.dataset.productUrl = button.dataset.variantUrl;
    }
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.slynara-product-card__colors').forEach((group) => {
      const selected = group.querySelector(`${buttonSelector}[aria-pressed='true']:not(:disabled)`);
      const available = group.querySelector(`${buttonSelector}:not(:disabled)`);
      selectSwatch(selected || available, false);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    selectSwatch(button);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();
